import React from "react";
import EbCompleteReviewModal from "../../../ExecutionBlueprint/ExecutionBlueprintReview/CompleteReviewModal";

// "Complete review & send to CEO" (§9.3 submit). The Execution Blueprint's
// modal, as the Annual OKR review uses it: its body is already the contract's
// shape (`note_to_ceo`, `scheduled_date`, `scheduled_time` `HH:mm`,
// `duration_minutes`), and its 5–480 minute range sits inside ours (1–600).
// The caller owns the request and its errors; this only maps the counts.
const ReviewCompleteModal = ({
  review,
  comments,
  submitting,
  onClose,
  onSubmit,
}) => (
  <EbCompleteReviewModal
    title="Review complete"
    itemNoun="Objective"
    totalItems={review.counts?.total ?? 0}
    acceptedCount={
      (review.counts?.marked ?? 0) - (review.counts?.to_discuss ?? 0)
    }
    toDiscussCount={review.counts?.to_discuss ?? 0}
    commentCount={comments.length}
    submitting={submitting}
    onCancel={onClose}
    onSubmit={onSubmit}
  />
);

export default ReviewCompleteModal;
